/**
 * What the task pane is told about where it runs (BON-1649): served by the add-in's own server as
 * `/config.json`, built from the service's environment at start, so one build serves staging and
 * production and nothing environment-specific is compiled into the bundle.
 *
 * None of it is secret. The client id and tenant id are in every token and in the manifest; the
 * add-in's app registration is a public client with no secret at all.
 */

export const ENVIRONMENTS = ['production', 'staging', 'local'] as const;
export type AddinEnvironment = (typeof ENVIRONMENTS)[number];

/** The delegated scope the add-in's app registration exposes, and the one Sumi requires. */
export const ACCESS_SCOPE = 'access_as_user';

export interface PaneConfig {
  environment: AddinEnvironment;
  /** The add-in's own origin, such as https://word.bonsai.blue. */
  publicUrl: string;
  /** Sumi's public origin, which the pane calls. */
  sumiUrl: string;
  /** The add-in's Entra app registration (application, client) id. */
  clientId: string;
  /** Bonsai's Entra tenant. */
  tenantId: string;
  /** True only in the local harness: Office is the in-memory fake and Sumi the stand-in. */
  harness: boolean;
}

/**
 * The registration's Application ID URI, api://<the add-in's host>/<client id>. Nested app
 * authentication does not require this form (legacy Office single sign-on did); it is kept because
 * registrations already carry it and it says whose API the scope is.
 */
export function applicationIdUri(config: Pick<PaneConfig, 'publicUrl' | 'clientId'>): string {
  return `api://${new URL(config.publicUrl).host}/${config.clientId}`;
}

/** The scope a sign-in asks for, fully qualified as Entra knows it. */
export function accessScope(config: Pick<PaneConfig, 'publicUrl' | 'clientId'>): string {
  return `${applicationIdUri(config)}/${ACCESS_SCOPE}`;
}
